/* eslint-disable */
export const getTextFromPTagRegex = (htmlElement) => {
  return htmlElement.replace(/(<([^>]+)>)/g, '');
};

const regex = {
  imageTag: /<img([\w\W]+?)[\/]?>/g,
  imageSrc: /src\s*=\s*"(.+?)"/,
  imageAlt: /alt\s*=\s*"(.+?)"/,
  markdownImage: /!\[.*\]\(.*\)/g,
  lineBreakTag: /<br>/g,
  nbsp: /&nbsp;/g,
  leftArrow: /&lt;/g,
  rightArrow: /&gt;/g,
  amp: /&amp;/g,
  copyTextSelectorRegex: /{{((\w\.?)+)}}/g,
  amazonOrderNumber: /([0-9]{3})-([0-9]{6,9})-([0-9]{6,9})/g,
  verticalSpace: /<p>\s*&nbsp;\s*<\/p>/gi,
  // Match an anchor regardless of attribute order (href may follow target/rel,
  // as rendered by the TipTap Link extension). href/text are extracted from the
  // matched substring via aHref/aTagWord, so this only needs to match the whole
  // <a ...>text</a>. Kept permissive so href-first (legacy) anchors still match.
  aTag: /<a\s[^>]*href=[^>]*>((?:.(?!<\/a>))*.)<\/a>/gi,
  aHref: /href\s*=\s*"(.+?)"/i,
  aTagValue: /value\s*=\s*"(.+?)"/i,
  aTagWord: /.+>(.+?)<\//i,
  openParagraphTag: /<p>/g,
  closeParagraphTag: /<\/p>/g,
  specialChars: /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
};

export default regex;
